import { useEffect, useState } from 'react';
import { convertToPdfAndDownload, isBuffer } from 'reactApp/utils/downloadDocumentHelpers';

import { ViewerPdfProps } from '../ViewerPdf';

const convertBufferToObjectURL = <T extends Uint8Array>(content: T) => {
    const blob = new Uint8Array(content);
    const file = new Blob([blob], { type: 'application/pdf' });

    return URL.createObjectURL(file);
};

export const useConvertDocumentToPdf = ({ storage, convert, url, ext }: Omit<ViewerPdfProps, 'renderError' | ' fillParent'>) => {
    const [error, setError] = useState<string | undefined>();
    const [fileURL, setFileURL] = useState<string>('');

    useEffect(() => {
        let cancel = false;
        if (!storage || !convert) {
            return;
        }

        const fetchDocumentData = async () => {
            const { content, error } = await convertToPdfAndDownload(url, { storage, ext });

            if (cancel) {
                return;
            }
            if (isBuffer(content)) {
                setFileURL(convertBufferToObjectURL(content));
                return;
            }

            if (error) {
                setError(error?.toString());
            }
        };

        fetchDocumentData();

        return () => {
            cancel = true;
            URL.revokeObjectURL(fileURL);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return { fileURL, error };
};
